import { type FC, type SVGProps } from 'react';
import {
  FacebookFooter,
  FacebookFooterUk,
  Instagram,
  InstagramUk,
  Tiktok,
  TiktokUk,
  X,
  XUk,
  YoutubeFooter,
  YoutubeFooterUk,
} from '@fpsm/cxy-icons/glyphs';

import { type SocialLink } from '../footer/types';

type SocialLinkTemplate = {
  SvgIcon: FC<SVGProps<SVGSVGElement>>;
  linkLabel: string;
  name: string;
};

const SOCIAL_LINK_TEMPLATES: SocialLinkTemplate[] = [
  {
    SvgIcon: YoutubeFooter,
    linkLabel: 'CX_SOCIAL_YOUTUBE_ACCOUNT',
    name: 'youtube',
  },
  {
    SvgIcon: Tiktok,
    linkLabel: 'CX_SOCIAL_TIKTOK_ACCOUNT',
    name: 'tiktok',
  },
  {
    SvgIcon: FacebookFooter,
    linkLabel: 'CX_SOCIAL_FACEBOOK_ACCOUNT',
    name: 'facebook',
  },
  {
    SvgIcon: Instagram,
    linkLabel: 'CX_SOCIAL_INSTAGRAM_ACCOUNT',
    name: 'instagram',
  },
  {
    SvgIcon: X,
    linkLabel: 'CX_SOCIAL_X_ACCOUNT',
    name: 'x',
  },
];

const SOCIAL_LINK_TEMPLATES_UK_STYLE: SocialLinkTemplate[] = [
  {
    SvgIcon: InstagramUk,
    linkLabel: 'CX_SOCIAL_INSTAGRAM_ACCOUNT',
    name: 'instagram',
  },
  {
    SvgIcon: FacebookFooterUk,
    linkLabel: 'CX_SOCIAL_FACEBOOK_ACCOUNT',
    name: 'facebook',
  },
  {
    SvgIcon: TiktokUk,
    linkLabel: 'CX_SOCIAL_TIKTOK_ACCOUNT',
    name: 'tiktok',
  },
  {
    SvgIcon: XUk,
    linkLabel: 'CX_SOCIAL_X_ACCOUNT',
    name: 'x',
  },
  {
    SvgIcon: YoutubeFooterUk,
    linkLabel: 'CX_SOCIAL_YOUTUBE_ACCOUNT',
    name: 'youtube',
  },
];

// i18next returns the key itself when a translation is missing; treat that as "platform not configured".
const buildSocialLinks = (templates: SocialLinkTemplate[], t: (key: string) => string): SocialLink[] =>
  templates.flatMap(({ SvgIcon, linkLabel, name }) => {
    const href = t(linkLabel);
    return href && href !== linkLabel ? [{ SvgIcon, href, name }] : [];
  });

export const getSocialLinks = (t: (key: string) => string): SocialLink[] => buildSocialLinks(SOCIAL_LINK_TEMPLATES, t);

export const getSocialLinksUkStyle = (t: (key: string) => string): SocialLink[] =>
  buildSocialLinks(SOCIAL_LINK_TEMPLATES_UK_STYLE, t);
